<template>
  <div class="mx-23.5">
    <img src="@/assets/images/blog/0/second.png" :src="require('@/assets/images/blog/' + source)" class="mb-7.5" alt="">
    <span class="text-gray fz-16 font-medium" style="line-height:1.5625">
      {{marks.join(' ')}}
    </span>
  </div>
</template>

<script>
export default {
  name: "imageWithMark",
  props: ['source', 'marks']
}
</script>

<style scoped>

</style>